import * as i0 from '@angular/core';
import { inject, ComponentRef, Component, ChangeDetectionStrategy, Optional, Input, ViewChild, HostListener, NgModule } from '@angular/core';
import * as i5 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@spartacus/cart/base/root';
import { CartOutlets, CartUiEventAddToCart } from '@spartacus/cart/base/root';
import * as i3 from '@spartacus/core';
import { FeatureConfigService, FeatureToggles, ProductAvailabilityService, useFeatureStyles, ProductScope, isNotNullable, I18nModule, FeaturesConfigModule, provideDefaultConfig } from '@spartacus/core';
import * as i1 from '@spartacus/storefront';
import { ICON_TYPE, IconModule, ItemCounterModule, OutletModule } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { map, filter, take } from 'rxjs/operators';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = ["addToCartDialogTriggerEl"];
function AddToCartComponent_form_0_div_1_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "addToCart.quantityFull"));
  }
}
function AddToCartComponent_form_0_div_1_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "addToCart.quantity"));
  }
}
function AddToCartComponent_form_0_div_1_cx_item_counter_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-item-counter", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("max", ctx_r1.maxQuantity)("control", ctx_r1.addToCartForm.get("quantity"))("ariaDescribedById", "add-to-card-stock-info");
  }
}
function AddToCartComponent_form_0_div_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getInventory());
  }
}
function AddToCartComponent_form_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, AddToCartComponent_form_0_div_1_label_1_Template, 3, 3, "label", 7)(2, AddToCartComponent_form_0_div_1_label_2_Template, 3, 3, "label", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, AddToCartComponent_form_0_div_1_cx_item_counter_4_Template, 1, 3, "cx-item-counter", 9);
    i0.ɵɵelementStart(5, "span", 10);
    i0.ɵɵtemplate(6, AddToCartComponent_form_0_div_1_span_6_Template, 2, 1, "span", 4);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasStock);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 5, ctx_r1.showInventory$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hasStock ? i0.ɵɵpipeBind1(9, 7, "addToCart.inStock") : i0.ɵɵpipeBind1(10, 9, "addToCart.outOfStock"), "");
  }
}
function AddToCartComponent_form_0_ng_container_2_ng_template_1_Template(rf, ctx) {}
function AddToCartComponent_form_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AddToCartComponent_form_0_ng_container_2_ng_template_1_Template, 0, 0, "ng-template", 12);
    i0.ɵɵtwoWayListener("cxComponentRefChange", function AddToCartComponent_form_0_ng_container_2_Template_ng_template_cxComponentRefChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.pickupOptionCompRef, $event) || (ctx_r1.pickupOptionCompRef = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("cxComponentRefChange", function AddToCartComponent_form_0_ng_container_2_Template_ng_template_cxComponentRefChange_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onPickupOptionsCompLoaded());
    });
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.CartOutlets.ADD_TO_CART_PICKUP_OPTION);
    i0.ɵɵtwoWayProperty("cxComponentRef", ctx_r1.pickupOptionCompRef);
  }
}
function AddToCartComponent_form_0_button_3_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵelement(1, "cx-icon", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconTypes.REPEAT);
  }
}
function AddToCartComponent_form_0_button_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 13, 0);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, AddToCartComponent_form_0_button_3_span_4_Template, 2, 1, "span", 14);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementStart(6, "span", 15);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_8_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", (ctx_r1.options == null ? null : ctx_r1.options.displayAddToCart) ? "btn btn-tertiary" : "btn btn-primary btn-block")("disabled", ctx_r1.disabled || ctx_r1.quantity <= 0 || ctx_r1.quantity > ctx_r1.maxQuantity);
    i0.ɵɵattribute("aria-label", (ctx_r1.product == null ? null : ctx_r1.product.name) ? i0.ɵɵpipeBind1(2, 6, "addToCart.addToCart") + ", " + (ctx_r1.product == null ? null : ctx_r1.product.name) : i0.ɵɵpipeBind1(3, 8, "addToCart.addToCart"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", (ctx_r1.options == null ? null : ctx_r1.options.addToCartString) === i0.ɵɵpipeBind1(5, 10, "addToCart.buyItAgain"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", (ctx_r1.options == null ? null : ctx_r1.options.addToCartString) === i0.ɵɵpipeBind1(7, 12, "addToCart.buyItAgain") ? "buyItAgainLink" : "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (tmp_8_0 = ctx_r1.options == null ? null : ctx_r1.options.addToCartString) !== null && tmp_8_0 !== undefined ? tmp_8_0 : i0.ɵɵpipeBind1(9, 14, "addToCart.addToCart"), " ");
  }
}
function AddToCartComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("submit", function AddToCartComponent_form_0_Template_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addToCart());
    });
    i0.ɵɵtemplate(1, AddToCartComponent_form_0_div_1_Template, 11, 11, "div", 3)(2, AddToCartComponent_form_0_ng_container_2_Template, 2, 2, "ng-container", 4)(3, AddToCartComponent_form_0_button_3_Template, 10, 16, "button", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.addToCartForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showQuantity);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasStock);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hasStock);
  }
}
let AddToCartComponent = /*#__PURE__*/(() => {
  class AddToCartComponent {
    /**
     * We disable the dialog launch on quantity input,
     * as it causes an unexpected change of context.
     * The expectation is only for the quantity to get updated in the Qty field.
     */
    handleKeyboardEvent(event) {
      const eventTarget = event.target;
      const isQuantityInput = eventTarget.ariaLabel === 'Quantity' && eventTarget.tagName === 'INPUT';
      if (event.key === 'Enter' && isQuantityInput) {
        event.preventDefault();
      }
    }
    constructor(currentProductService, cd, activeCartService, component, eventService, productListItemContext) {
      this.currentProductService = currentProductService;
      this.cd = cd;
      this.activeCartService = activeCartService;
      this.component = component;
      this.eventService = eventService;
      this.productListItemContext = productListItemContext;
      this.showQuantity = true;
      this.disabled = false;
      this.hasStock = false;
      this.inventoryThreshold = false;
      this.showInventory$ = this.component?.data$.pipe(map(data => data.inventoryDisplay));
      this.quantity = 1;
      this.subscription = new Subscription();
      this.addToCartForm = new UntypedFormGroup({
        quantity: new UntypedFormControl(1, {
          updateOn: 'blur'
        })
      });
      this.CartOutlets = CartOutlets;
      this.iconTypes = ICON_TYPE;
      this.featureConfigService = inject(FeatureConfigService);
      this.featureToggles = inject(FeatureToggles);
      this.productAvailabilityService = inject(ProductAvailabilityService);
      useFeatureStyles('a11yQTY2Quantity');
    }
    ngOnInit() {
      if (this.product) {
        this.productCode = this.product.code ?? '';
        this.setStockInfo(this.product);
      } else if (this.productCode) {
        // force hasStock and quantity for the time being, as we do not have more info:
        this.quantity = 1;
        this.hasStock = true;
        this.cd.markForCheck();
      } else {
        let product$;
        if (this.productListItemContext) {
          product$ = this.productListItemContext.product$;
        } else if (this.featureToggles.showRealTimeStockInPDP) {
          product$ = this.currentProductService.getProduct([ProductScope.UNIT, ProductScope.DETAILS]);
        } else {
          product$ = this.currentProductService.getProduct();
        }
        this.subscription.add(product$.pipe(filter(isNotNullable)).subscribe(product => {
          this.productCode = product.code ?? '';
          this.product = product;
          this.setStockInfo(product);
        }));
      }
    }
    setStockInfo(product) {
      this.quantity = 1;
      this.addToCartForm.controls['quantity'].setValue(1);
      this.inventoryThreshold = product.stock?.isValueRounded ?? false;
      if (this.productListItemContext) {
        this.showQuantity = false;
      }
      /**
       * When removing the feature toggle in the future, let's leave the if-else block.
       * In case of absent sapUnit we want to fallback to the stock info from the product object.
       */
      if (this.featureToggles.showRealTimeStockInPDP && product.sapUnit?.sapCode) {
        this.productAvailabilityService.getRealTimeStock(this.productCode, product.sapUnit?.sapCode).pipe(take(1)).subscribe(({
          quantity,
          status
        }) => {
          this.maxQuantity = Number(quantity);
          this.hasStock = Boolean(status && status !== 'OUT_OF_STOCK');
          this.cd.markForCheck();
        });
      } else {
        this.hasStock = Boolean(product.stock?.stockLevelStatus !== 'outOfStock');
        if (this.hasStock && product.stock?.stockLevel) {
          this.maxQuantity = product.stock.stockLevel;
        }
        this.cd.markForCheck();
      }
    }
    /**
     * In specific scenarios, we need to omit displaying the stock level or append a plus to the value.
     * When backoffice forces a product to be in stock, omit showing the stock level.
     * When product stock level is limited by a threshold value, append '+' at the end.
     * When out of stock, display no numerical value.
     */
    getInventory() {
      if (this.hasStock) {
        const quantityDisplay = this.maxQuantity ? this.maxQuantity.toString() : '';
        return this.inventoryThreshold ? quantityDisplay + '+' : quantityDisplay;
      } else {
        return '';
      }
    }
    updateCount(value) {
      this.quantity = value;
    }
    addToCart() {
      let quantity = 0;
      if (this.savedCart) {
        quantity = this.getQuantityFromSavedCart(this.productCode);
      } else {
        quantity = this.addToCartForm.get('quantity')?.value;
      }
      if (!this.productCode || quantity <= 0) {
        return;
      }
      if (this.pickupOptionCompRef instanceof ComponentRef) {
        this.pickupOptionCompRef.instance.intendedPickupLocation$.pipe(take(1)).subscribe(intendedPickupLocation => {
          this.pickupStore = intendedPickupLocation?.pickupOption === 'pickup' ? intendedPickupLocation.name : undefined;
        });
      }
      this.activeCartService.getEntries().pipe(take(1)).subscribe(cartEntries => {
        this.activeCartService.addEntry(this.productCode, quantity, this.pickupStore);
        // A CartUiEventAddToCart is dispatched.  This event is intended for the UI
        // responsible to provide feedback about what was added to the cart, like
        // the added to cart dialog.
        //
        // Because we call activeCartService.getEntries() before, we can be sure the
        // cart library is loaded already and that the event listener exists.
        this.eventService.dispatch(this.createCartUiEventAddToCart(this.productCode, quantity, cartEntries.length, this.pickupStore));
      });
    }
    createCartUiEventAddToCart(productCode, quantity, numberOfEntriesBeforeAdd, storeName) {
      const newEvent = new CartUiEventAddToCart();
      newEvent.productCode = productCode;
      newEvent.quantity = quantity;
      newEvent.numberOfEntriesBeforeAdd = numberOfEntriesBeforeAdd;
      newEvent.pickupStoreName = storeName;
      if (this.featureConfigService.isEnabled('a11yDialogTriggerRefocus')) {
        newEvent.triggerElementRef = this.addToCartDialogTriggerEl;
      }
      return newEvent;
    }
    onPickupOptionsCompLoaded() {
      if (this.featureConfigService.isEnabled('a11yPickupOptionsTabs') && this.pickupOptionCompRef instanceof ComponentRef) {
        this.subscription.add(this.pickupOptionCompRef.instance.intendedPickupChange.subscribe(intendedPickupLocation => {
          this.disabled = intendedPickupLocation?.pickupOption === 'pickup' && !intendedPickupLocation.displayName;
        }));
      }
    }
    getQuantityFromSavedCart(productCode) {
      return this.savedCart?.entries?.find(e => e?.product?.code === productCode)?.quantity ?? 0;
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function AddToCartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddToCartComponent)(i0.ɵɵdirectiveInject(i1.CurrentProductService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.ActiveCartFacade), i0.ɵɵdirectiveInject(i1.CmsComponentData), i0.ɵɵdirectiveInject(i3.EventService), i0.ɵɵdirectiveInject(i1.ProductListItemContext, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddToCartComponent,
        selectors: [["cx-add-to-cart"]],
        viewQuery: function AddToCartComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addToCartDialogTriggerEl = _t.first);
          }
        },
        hostBindings: function AddToCartComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function AddToCartComponent_keydown_HostBindingHandler($event) {
              return ctx.handleKeyboardEvent($event);
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          productCode: "productCode",
          showQuantity: "showQuantity",
          options: "options",
          pickupStore: "pickupStore",
          savedCart: "savedCart",
          product: "product"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["addToCartDialogTriggerEl", ""], [3, "formGroup", "submit", 4, "ngIf"], [3, "submit", "formGroup"], ["class", "quantity", 4, "ngIf"], [4, "ngIf"], ["type", "submit", 3, "ngClass", "disabled", 4, "ngIf"], [1, "quantity"], [4, "cxFeature"], [1, "cx-counter-stock"], [3, "max", "control", "ariaDescribedById", 4, "ngIf"], ["id", "add-to-card-stock-info", 1, "info"], [3, "max", "control", "ariaDescribedById"], [3, "cxComponentRefChange", "cxOutlet", "cxComponentRef"], ["type", "submit", 3, "ngClass", "disabled"], ["class", "repeat-icon", 4, "ngIf"], [3, "ngClass"], [1, "repeat-icon"], [3, "type"]],
        template: function AddToCartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AddToCartComponent_form_0_Template, 4, 4, "form", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.productCode);
          }
        },
        dependencies: [i4.NgClass, i4.NgIf, i5.ɵNgNoValidate, i5.NgControlStatusGroup, i5.FormGroupDirective, i1.IconComponent, i1.ItemCounterComponent, i1.OutletDirective, i3.FeatureDirective, i4.AsyncPipe, i3.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return AddToCartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let AddToCartModule = /*#__PURE__*/(() => {
  class AddToCartModule {
    static {
      this.ɵfac = function AddToCartModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddToCartModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddToCartModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            ProductAddToCartComponent: {
              component: AddToCartComponent,
              data: {
                inventoryDisplay: false
              }
            }
          }
        })],
        imports: [CommonModule, ReactiveFormsModule, I18nModule, IconModule, ItemCounterModule, OutletModule, FeaturesConfigModule]
      });
    }
  }
  return AddToCartModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddToCartComponent, AddToCartModule };
